module.exports = __webpack_public_path__ + "img/fa-quote-left.bcf9c0a7.png";